import React, { FormEventHandler } from 'react';
import { connect } from 'dva';
import Radio from '@mos-cat/radio';
import { Heading } from '@mos-cat/typography';
import { Select, t, Trans } from '@lingui/macro';
import { Dispatch } from 'redux';
import { SECOND_PARENT_FIELD_NAME } from '../../../constants/fieldNames';
import { isApplicantMarried } from '../../../selectors/applicant';
import { SECOND_PARENT_STATUS } from '../../../constants/secondParentStatus';

import { getValue } from '../../../constants/getFieldValues';
import { BORN_IN_MARRIAGE } from '../../../constants/child';
import { Field } from '../../../declarations/widget-ums';
import { Sex } from '../../shared/PersonGender/PersonGender';

interface Props {
  status: Field<'single' | 'paternity' | 'widowed' | 'divorced' | null>;
  isVisible: boolean;
  sexOfParent: Sex;
  onChange: FormEventHandler;
}

const parentStatusText = {
  paternity: t`В отношении ребёнка установлено отцовство`,
  widowed: t`Второй родитель ребёнка умер`,
  divorced: t`Брак с родителем ребёнка расторгнут`
};

function SecondParentStatus({
  isVisible,
  onChange,
  status,
  sexOfParent
}: Props): JSX.Element | null {
  if (!isVisible) return null;
  const { value, error, disabled } = status;

  return (
    <div className="StepContentBlock">
      <Heading level={3} className="PguFormGrid__row">
        <Trans>Дополнительные сведения о родителе ребёнка</Trans>
      </Heading>
      <div className="PguFormGrid__row">
        <Radio
          className="PguFormGrid_col"
          label={
            <Select
              value={sexOfParent}
              m="Ребёнок одинокого отца"
              f="Ребёнок одинокой матери"
              other="Ребёнок одинокой матери (отца)"
            />
          }
          name={SECOND_PARENT_FIELD_NAME.status}
          value={SECOND_PARENT_STATUS.single}
          checked={value === SECOND_PARENT_STATUS.single}
          error={error}
          disabled={disabled}
          onChange={onChange}
        />
      </div>
      <div className="PguFormGrid__row">
        <Radio
          className="PguFormGrid_col"
          label={
            <Trans id={parentStatusText[SECOND_PARENT_STATUS.paternity]} />
          }
          name={SECOND_PARENT_FIELD_NAME.status}
          value={SECOND_PARENT_STATUS.paternity}
          checked={value === SECOND_PARENT_STATUS.paternity}
          error={error}
          disabled={disabled}
          onChange={onChange}
        />
      </div>
      <div className="PguFormGrid__row">
        <Radio
          className="PguFormGrid_col"
          label={<Trans id={parentStatusText[SECOND_PARENT_STATUS.widowed]} />}
          name={SECOND_PARENT_FIELD_NAME.status}
          value={SECOND_PARENT_STATUS.widowed}
          checked={value === SECOND_PARENT_STATUS.widowed}
          error={error}
          disabled={disabled}
          onChange={onChange}
        />
      </div>
      <div className="PguFormGrid__row">
        <Radio
          className="PguFormGrid_col"
          label={<Trans id={parentStatusText[SECOND_PARENT_STATUS.divorced]} />}
          name={SECOND_PARENT_FIELD_NAME.status}
          value={SECOND_PARENT_STATUS.divorced}
          checked={value === SECOND_PARENT_STATUS.divorced}
          error={error}
          disabled={disabled}
          onChange={onChange}
        />
      </div>
    </div>
  );
}

function mapStateToProps({
  applicant,
  spouse,
  child: {
    bornInNotCurrentMarriage,
    secondParent: { status }
  }
}) {
  const isMarried = isApplicantMarried({
    applicant
  });
  const bornInNotCurrentMarriageValue = getValue(bornInNotCurrentMarriage);
  const sexOfParent =
    bornInNotCurrentMarriageValue === BORN_IN_MARRIAGE.ofSpouse
      ? getValue(spouse.sex)
      : getValue(applicant.sex);
  return {
    isVisible: !isMarried || !!bornInNotCurrentMarriage.value,
    status,
    sexOfParent
  };
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onChange({ target: { name, value } }) {
    dispatch({
      type: 'child/secondParent/reset/status',
      payload: { [name]: { value } }
    });
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SecondParentStatus);
